import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { MaintenanceProductPrice } from '../../../recommendations/types';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { toApiError } from '../utils';

export interface PlanFertilizationPayload {
	planId: string;
	method: 'broad' | 'irrigation';
	period: [string, string];
	packId?: string;
	productPrices?: Array<Omit<MaintenanceProductPrice, 'pricePerKg'>>;
}

export function usePostPlanFertilization() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation<unknown[], Error, PlanFertilizationPayload>({
		mutationFn: async (payload) => {
			try {
				const { data } = await api.post<unknown[]>(
					'/advices/fertilization-plan/plan-fertilization',
					payload,
					{ params: { forBinding } }
				);
				return Array.isArray(data) ? data : [];
			} catch (error) {
				throw toApiError(error, 'Erro ao calcular o planejamento');
			}
		},
		onSuccess: (_data, variables) => {
			queryClient.invalidateQueries({ queryKey: ['maintenance', variables.planId] });
		},
	});
}
